import { Effect } from 'effect';
import { appUrlEffect } from './brand';
import { isAppHostEffect } from './host';

/**
 * The Links tab (W.4.124 R4): every hosted link with its views, and the place a
 * signed-in visitor creates one. It replaced the Analytics tab; `/analytics`
 * redirects here.
 */
export const LINKS_DASHBOARD_PATH = '/links';
/** Create a link: the signed-in PDF to Link screen, inside the Links tab. */
export const LINKS_CREATE_PATH = '/links/new';
/** Names a link just created on another page, so Links shows it first. */
export const LINKS_CREATED_PARAM = 'created';
/**
 * One link's own page (W.4.124 R6): its settings, then its views. The
 * `/settings` tail keeps a link named `new` clear of Create link.
 */
export function linkSettingsPath(namespace: string): string {
  return `${LINKS_DASHBOARD_PATH}/${encodeURIComponent(namespace)}/settings`;
}

/** An app path as is on the app host, or as an absolute app URL elsewhere. */
const appHostHrefEffect = Effect.fn('web.links.appHostHref')(function* (path: string) {
  if (yield* isAppHostEffect()) return path;
  return yield* appUrlEffect(path);
});

export const linksDashboardHrefEffect = Effect.fn('web.links.dashboardHref')(function* () {
  return yield* appHostHrefEffect(LINKS_DASHBOARD_PATH);
});

export function linksDashboardHref(): string {
  return Effect.runSync(linksDashboardHrefEffect());
}

export function linksCreateHref(): string {
  return Effect.runSync(appHostHrefEffect(LINKS_CREATE_PATH));
}

/** The Links tab with `namespace` shown first, as the link just created. */
export function linksCreatedHref(namespace: string): string {
  const query = new URLSearchParams({ [LINKS_CREATED_PARAM]: namespace }).toString();
  return Effect.runSync(appHostHrefEffect(`${LINKS_DASHBOARD_PATH}?${query}`));
}
